import { c as _c } from "react/compiler-runtime";
import { GlueErrorResponse } from '@/src/lib/glue/types';
import { useFormHelpers } from '@/src/lib/utils/form-helpers';
import { useRouter } from 'next/navigation';
import { startTransition } from 'react';
import { Dictionary } from '@/src/lib/dictionary/types';
import { NotificationMode } from '@/src/app/components/Notification/types';
import { revalidateTagAction } from '@/src/lib/revalidate/business/revalidate-tag.action';
import { SELF_URL } from '../../core/config';
import { handleException } from '@/src/lib/core/exception/handle-exception';
export function useSessionGuard(dict) {
  const $ = _c(4);
  const {
    handleErrors
  } = useFormHelpers(dict);
  const router = useRouter();
  let t0;
  if ($[0] !== dict || $[1] !== handleErrors || $[2] !== router) {
    const handleProtectedRouteErrors = async function handleProtectedRouteErrors(error, t1, setErrors, t2, t3) {
      const redirectPath = t1 === undefined ? "/" : t1;
      const displayGenericError = t2 === undefined ? false : t2;
      const useToast = t3 === undefined ? false : t3;
      const errorMessage = displayGenericError ? dict.general.error : error;
      const {
        triggerPageRefresh,
        triggerPageRefreshAndLogout,
        revalidateTag: tagToRevalidate
      } = handleErrors(errorMessage, useToast, setErrors);
      handleException(error);
      if (tagToRevalidate) {
        await revalidateTagAction(tagToRevalidate);
      }
      if (triggerPageRefresh) {
        startTransition(() => {
          router.push(`${redirectPath}`);
        });
        return;
      }
      if (triggerPageRefreshAndLogout) {
        localStorage.setItem("redirectAfterLogoutData", JSON.stringify({
          url: redirectPath,
          message: {
            message: dict.messages.generic.notAuthorized,
            mode: NotificationMode.TOAST
          }
        }));
        startTransition(() => {
          router.push(`/auth/logout?returnTo=${new URL("/logout-with-redirect", SELF_URL).toString()}`);
        });
      }
    };
    t0 = {
      handleProtectedRouteErrors
    };
    $[0] = dict;
    $[1] = handleErrors;
    $[2] = router;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}